import { RootState } from 'store';

export const selectAllProperties = (state:RootState) => state.properties.properties;
export const selectTotal = (state:RootState) => state.properties.total;
